<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex align-items-center">
        <b-button to="/settings" variant="outline" class="text-primary">
          <feather-icon icon="ArrowLeftIcon" /> Back to Settings
        </b-button>
        <div>
          <h3 class="font-weight-bolder mb-0">Security & Compliance</h3>
          <p class="text-muted mb-0">
            Manage security protocols, audit trails, and regulatory compliance
          </p>
        </div>
      </div>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-row>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #dcfce7"
              >
                <feather-icon icon="ShieldIcon" style="color: #00a63e" />
              </div>
              <div>
                <span class="text-muted">Security Score</span>
                <h4 class="font-weight-bolder mb-0">4%</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #dbeafe"
              >
                <feather-icon icon="CheckCircleIcon" style="color: #155dfc" />
              </div>
              <div>
                <span class="text-muted">Active Policies</span>
                <h4 class="font-weight-bolder mb-0">5</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #ffedd4"
              >
                <feather-icon icon="AlertTriangleIcon" style="color: #f54a00" />
              </div>
              <div>
                <span class="text-muted">Compliance Issues</span>
                <h4 class="font-weight-bolder mb-0">1</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col cols="6" md="3">
          <b-card border-variant="secondary">
            <div class="d-flex align-items-center" style="gap: 12px">
              <div
                class="rounded-pill d-flex align-items-center justify-content-center"
                style="width: 36px; height: 36px; background: #ffe2e2"
              >
                <feather-icon icon="EyeIcon" style="color: #e7000b" />
              </div>
              <div>
                <span class="text-muted">Security Incidents</span>
                <h4 class="font-weight-bolder mb-0">2</h4>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-tabs pills active-nav-item-class="active">
        <b-tab title="Security" active>
          <template #title>
            <feather-icon icon="ShieldIcon" /> <strong>Security</strong>
          </template>
          <Security />
        </b-tab>
        <b-tab title="Compliance">
          <template #title>
            <feather-icon icon="FileTextIcon" /> <strong>Compliance</strong>
          </template>
          <Compliance />
        </b-tab>
        <b-tab title="Monitoring">
          <template #title>
            <feather-icon icon="EyeIcon" /> <strong>Monitoring</strong>
          </template>
          <Monitoring />
        </b-tab>
        <b-tab title="Reports">
          <template #title>
            <feather-icon icon="DownloadIcon" /> <strong>Reports</strong>
          </template>
          <Reports />
        </b-tab>
      </b-tabs>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BFormCheckbox,
  BTab,
  BTabs,
} from "bootstrap-vue";
import Security from "./Security.vue";
import Compliance from "./Compliance.vue";
import Monitoring from "./Monitoring.vue";
import Reports from "./Reports.vue";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BFormCheckbox,
    BTab,
    BTabs,
    Security,
    Compliance,
    Monitoring,
    Reports,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.nav-pills {
  border-bottom: 1px solid #e5e7eb;
  background: #ececf0;
  border-radius: 12px;
  padding: 5px;
  width: 100%;
  .nav-item {
    flex-grow: 1;
  }
}
.nav-pills .nav-link {
  border-radius: 12px;
  color: black;
  background: transparent;
  padding: 8px;
  transition: all 0.2s ease;
  border: none;
}
.nav-pills .nav-link.active {
  background: white !important;
  color: black !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
